<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title text-info">승인 대기중인 회원이 <span class="text-danger">{{items.length}}</span>명 있습니다.</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">

        <el-row :gutter="10">
        <el-col :span="24" class="mt-2">
          <el-table class="table-striped"
                    border
                    style="width: 100%; margin-bottom: 10px"
                    :data="items"
                    ref="contractsTable"
                    :header-cell-style="tableRowStyle">
            <el-table-column
              prop="companyName"
              label="업체명">
            </el-table-column>
            <el-table-column
              prop="userId"
              label="아이디">
            </el-table-column>
            <el-table-column
              prop="userName"
              label="이름">
            </el-table-column>
            <el-table-column
              prop="department"
              label="부서">
            </el-table-column>

            <el-table-column
              prop="regDate"
              label="가입일">
              <template slot-scope="props">
              <span >{{ props.row.regDate | moment('YYYY-MM-DD HH:mm') }}</span>
            </template>
            </el-table-column>

          </el-table>
        </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
          <el-button type="primary" @click="gotoAccount">계정관리로 이동</el-button>
          <el-button @click="$emit('dismiss')">닫 기</el-button>
      </div>
    </div>

</template>

<script>

import RmsDamdangFormModalVue from './RmsDamdangFormModal.vue';

export default {
    props: {
        items: {
            type: Array
        }
    },
    data() {
      return {
      }
    },    
    methods: {
        gotoAccount() {
          this.$router.push({name:'SettingsAccount', params:{searchStatus:'READY'}})
          this.$emit('close')
        },
        tableRowStyle() {
            return this.$store.state.common.tableHeaderCellStyle;
        },
    },

}
</script>